import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { THEME, TonConnectUIProvider } from '@tonconnect/ui-react';
import App from './App';
import { initTelegram } from './lib/telegram';
import { tonConnectManifestUrl, twaReturnUrl } from './lib/ton';
import './index.css';

initTelegram();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5,
      retry: 2,
    },
  },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <TonConnectUIProvider
        manifestUrl={tonConnectManifestUrl()}
        restoreConnection
        uiPreferences={{ theme: THEME.DARK, borderRadius: 'none' }}
        actionsConfiguration={{ twaReturnUrl: twaReturnUrl() }}
      >
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </TonConnectUIProvider>
    </QueryClientProvider>
  </StrictMode>
);
